import { PASS_DISP_TYPE } from "../constants/passDispType";

/**
 * passDispTypeがQrSliderかどうかを判定する
 * @param {Object} params
 * @param {string} params.passDispType
 * @returns {boolean}
 */
export const checkIsQrSliderPass = ({ passDispType }) => {
  return passDispType === PASS_DISP_TYPE.QR_SLIDER;
};
